import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { ButtonAdd } from '../../../components/common/buttons';
import { AdsIndexTable } from '../../../components/advertisers/ads';

class Index extends Component {
  redirectToNew() {
    const { dispatch, account } = this.props;
    dispatch(push(`/advertiser/home/accounts/${account.slug}/ads/new`));
  }

  render() {
    const { account, isLoading } = this.props;

    return (
      <div className='ibox'>
        <div className='ibox-title border-bottom'>
          <h5>Ads</h5>
        </div>

        <div
          className={`p-b-lg ibox-content${isLoading ? ' sk-loading' : ''}`}
        >
          <AdsIndexTable account={account}>
            <ButtonAdd
              btnLabel='Create Ad'
              onClick={this.redirectToNew.bind(this)}
            />
          </AdsIndexTable>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const {
    advertiser: {
      ads: {
        data: ads, loading: isLoading
      },
      accounts
    }
  } = state;

  const { params: { accountSlug } } = ownProps;
  const account = (accounts.data.data || [])
    .filter((w) => w.slug === accountSlug)[0] || {};

  return {
    ads,
    isLoading,
    account
  };
};

export default connect(mapStateToProps)(Index);
